export default __webpack_public_path__ + "static/media/update.7eac9d46.jpg";